import { Helmet } from "react-helmet"
import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ServiceDetails3 from "../components/sections/ServiceDetails3"
// import Imgsec1 from "../components/sections/imgsec1"
export default function ServicesDetails() {
	return (
		<>
			<Helmet>
				<title>V-Make | WPC Foam Board</title>
				<meta name="description" content="V-Make WPC Foam Boards are durable, moisture-resistant, and eco-friendly—ideal for modern interiors, partitions, kitchen cabinets, and more." />
				<meta name="keywords" content="WPC Foam Board, V-Make foam board, wood plastic composite board, waterproof board, termite proof panel, interior partition board, eco-friendly foam board, durable WPC board" />
				<link rel="canonical" href="https://vmakewpc.com/Wpc-Foam-Board" />
				<meta property="og:title" content="WPC Foam Board | V-Make" />
				<meta property="og:description" content="Explore our premium WPC Foam Boards—perfect for furniture, kitchens, partitions, and modular interiors. Resistant to water, termites, and built for durability." />
				<meta property="og:url" content="https://vmakewpc.com/Wpc-Foam-Board" />
				<meta property="og:image" content="https://vmakewpc.com/assets/img/service/Formboard-1.jpg" />
			</Helmet>
			<Layout
				headerStyle={1}
				footerStyle={1}
			// breadcrumbTitle="Services details"
			>
				<ServiceDetails3 />
				{/* <Brand1 /> */}
				{/* <Imgsec1 /> */}
			</Layout>
		</>
	)
}
